import React, { useState, useEffect } from 'react';
import { getLimeAdjustedGroups, getLimeStats } from '../../../lib/api';
import { AdjustmentTab } from '../../../components/AdjustmentTab';
import { getChartColors } from '../../../services/chart-colors';

export function LimeAdjustments(props) {
  const {
    onLoad,
    onGroupsAdjustment,
    onFieldAdjustment,
    field,
    ...passThrough
  } = props;

  const [stats, setStats] = useState(null);
  const [groups, setGroups] = useState([]);

  const fieldAdjustment = field.fullFieldAdjustment || 0;

  useEffect(() => {
    Promise.all([getLimeStats(field), getLimeAdjustedGroups(field)])
      .then(([lStats, lGroups]) => {
        if (!lStats) throw new Error('no rx');
        setStats(lStats);
        setGroups(lGroups);
        onLoad('l', lGroups, fieldAdjustment);
      })
      .catch(() => onLoad('l'));
  }, [field, fieldAdjustment, onLoad]);

  return (
    stats && (
      <AdjustmentTab
        {...passThrough}
        ceiling={8000}
        multipleOf={500}
        stats={stats}
        groups={groups}
        fieldAdjustment={fieldAdjustment}
        colors={getChartColors('lime-rx')}
        onGroupsAdjustment={(newGroups) => onGroupsAdjustment('l', newGroups)}
        onFieldAdjustment={(adjustment) => onFieldAdjustment('l', adjustment)}
      />
    )
  );
}
